import { SIGNALS_EXPLANATION, type ProfileSignal } from "@fusiqo/vozqi-shared";

/**
 * «Señales verificadas» (spec 2026-10-20 §5.1): VozQI's word, not the
 * business's. Never a loose «Verificado» badge -- the block says where its
 * lines come from, under «¿Qué significa?».
 */
export function ProfileSignals({ signals }: { signals: ProfileSignal[] }) {
  if (signals.length === 0) return null;
  return (
    <section className="profile-section" aria-labelledby="profile-signals">
      <h2 id="profile-signals" className="profile-section-title">
        Señales verificadas
      </h2>
      <ul className="profile-signals">
        {signals.map((signal) => (
          <li key={signal.id}>
            <CheckMark />
            <span>{signal.label}</span>
          </li>
        ))}
      </ul>
      <details className="profile-why">
        <summary>¿Qué significa?</summary>
        <p>{SIGNALS_EXPLANATION}</p>
      </details>
    </section>
  );
}

function CheckMark() {
  return (
    <svg className="profile-check" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false">
      <circle cx="10" cy="10" r="10" fill="currentColor" />
      <path fill="var(--surface)" d="M8.4 13.6 5.2 10.4l1.2-1.2 2 2 4.9-4.9 1.2 1.2z" />
    </svg>
  );
}
